var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstant3Quotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9952 42.7455C45.614 42.7455 45.3145 43.0178 45.3145 43.3581C45.3145 43.6985 45.6276 43.9708 45.9952 43.9708H58.3165C58.6977 43.9708 58.9972 43.6985 58.9972 43.3581C58.9972 43.0178 58.6841 42.7455 58.3165 42.7455H45.9952Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9952 46.4492C45.614 46.4492 45.3145 46.7215 45.3145 47.0619C45.3145 47.4023 45.6276 47.6746 45.9952 47.6746H58.3165C58.6977 47.6746 58.9972 47.4023 58.9972 47.0619C58.9972 46.7215 58.6841 46.4492 58.3165 46.4492H45.9952Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9952 50.1508C45.614 50.1508 45.3145 50.4231 45.3145 50.7635C45.3145 51.1038 45.6276 51.3761 45.9952 51.3761H58.3165C58.6977 51.3761 58.9972 51.1038 58.9972 50.7635C58.9972 50.4231 58.6841 50.1508 58.3165 50.1508H45.9952Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9952 53.8546C45.614 53.8546 45.3145 54.1268 45.3145 54.4672C45.3145 54.8076 45.6276 55.0799 45.9952 55.0799H54.4771C54.8583 55.0799 55.1579 54.8076 55.1579 54.4672C55.1579 54.1268 54.8447 53.8546 54.4771 53.8546H45.9952Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8991 38.1437H58.8466C60.4395 38.1437 61.7193 39.301 61.7193 40.7305V57.8578C61.7193 59.2873 60.4259 60.4446 58.8466 60.4446H45.8991C44.3061 60.4446 43.0264 59.2873 43.0264 57.8578V44.0797",
    stroke: "#02475E",
    strokeWidth: 2.30032,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0987 42.7455C16.7175 42.7455 16.418 43.0178 16.418 43.3581C16.418 43.6985 16.7311 43.9708 17.0987 43.9708H29.42C29.8012 43.9708 30.1007 43.6985 30.1007 43.3581C30.1007 43.0178 29.7876 42.7455 29.42 42.7455H17.0987Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0987 46.4492C16.7175 46.4492 16.418 46.7215 16.418 47.0619C16.418 47.4023 16.7311 47.6746 17.0987 47.6746H29.42C29.8012 47.6746 30.1007 47.4023 30.1007 47.0619C30.1007 46.7215 29.7876 46.4492 29.42 46.4492H17.0987Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0987 50.1508C16.7175 50.1508 16.418 50.4231 16.418 50.7635C16.418 51.1038 16.7311 51.3761 17.0987 51.3761H29.42C29.8012 51.3761 30.1007 51.1038 30.1007 50.7635C30.1007 50.4231 29.7876 50.1508 29.42 50.1508H17.0987Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0987 53.8546C16.7175 53.8546 16.418 54.1268 16.418 54.4672C16.418 54.8076 16.7311 55.0799 17.0987 55.0799H25.5806C25.9619 55.0799 26.2614 54.8076 26.2614 54.4672C26.2614 54.1268 25.9482 53.8546 25.5806 53.8546H17.0987Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0026 38.1437H29.9501C31.5431 38.1437 32.8228 39.301 32.8228 40.7305V57.8578C32.8228 59.2873 31.5294 60.4446 29.9501 60.4446H17.0026C15.4097 60.4446 14.1299 59.2873 14.1299 57.8578V44.0797",
    stroke: "#F78670",
    strokeWidth: 2.30032,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9835 15.6018C31.6023 15.6018 31.3027 15.8741 31.3027 16.2144C31.3027 16.5548 31.6159 16.8271 31.9835 16.8271H44.3048C44.686 16.8271 44.9855 16.5548 44.9855 16.2144C44.9855 15.8741 44.6723 15.6018 44.3048 15.6018H31.9835Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9835 19.3055C31.6023 19.3055 31.3027 19.5778 31.3027 19.9182C31.3027 20.2585 31.6159 20.5308 31.9835 20.5308H44.3048C44.686 20.5308 44.9855 20.2585 44.9855 19.9182C44.9855 19.5778 44.6723 19.3055 44.3048 19.3055H31.9835Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9835 23.0071C31.6023 23.0071 31.3027 23.2794 31.3027 23.6197C31.3027 23.9601 31.6159 24.2324 31.9835 24.2324H44.3048C44.686 24.2324 44.9855 23.9601 44.9855 23.6197C44.9855 23.2794 44.6723 23.0071 44.3048 23.0071H31.9835Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9835 26.7108C31.6023 26.7108 31.3027 26.9831 31.3027 27.3235C31.3027 27.6639 31.6159 27.9362 31.9835 27.9362H40.4654C40.8466 27.9362 41.1461 27.6639 41.1461 27.3235C41.1461 26.9831 40.833 26.7108 40.4654 26.7108H31.9835Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 1.44891,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8873 11H44.8349C46.4278 11 47.7076 12.1572 47.7076 13.5868V30.7141C47.7076 32.1436 46.4142 33.3008 44.8349 33.3008H31.8873C30.2944 33.3008 29.0146 32.1436 29.0146 30.7141V16.936",
    stroke: "#02475E",
    strokeWidth: 2.30032,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstant3Quotes);
export default __webpack_public_path__ + "static/media/Instant3Quotes.4cd7fea00d47a9d175b03ffc5cb87ff0.svg";
export { ForwardRef as ReactComponent };